import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-body" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "login-id" }, "ログインID（メールアドレス）", -1)
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "form-check" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "is-admin",
  class: "form-check-label"
}, "管理者", -1)
const _hoisted_7 = { class: "modal-footer" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "modal-footer"
}
const _hoisted_11 = { class: "form-check" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "can-initialize-password",
  class: "form-check-label"
}, "パスワード初期化する", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dismissible_alert = _resolveComponent("dismissible-alert")!
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_modal_base = _resolveComponent("modal-base")!

  return (_openBlock(), _createBlock(_component_modal_base, { onDismiss: _ctx.dismiss }, {
    title: _withCtx(() => [
      _createTextVNode(" ユーザー登録 ")
    ]),
    "modal-content": _withCtx(() => [
      _createElementVNode("form", {
        onKeyup: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args))),
        onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _withDirectives(_createElementVNode("input", {
              type: "email",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.loginId }]),
              id: "login-id",
              placeholder: "ログインID（メールアドレス）",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.values.loginId) = $event)),
              onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args)))
            }, null, 34), [
              [_vModelText, _ctx.values.loginId]
            ]),
            _createElementVNode("div", {
              class: "invalid-feedback",
              textContent: _toDisplayString(_ctx.errors.loginId)
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              class: "form-check-input",
              id: "is-admin",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.values.isAdmin) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.values.isAdmin]
            ]),
            _hoisted_6
          ]),
          _createVNode(_component_dismissible_alert, {
            color: "danger",
            message: _ctx.requestError,
            onDismiss: _cache[3] || (_cache[3] = ($event: any) => (_ctx.requestError = null)),
            class: "mt-2"
          }, null, 8, ["message"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
          }, "キャンセル"),
          (_ctx.isAdd)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onClickedAdd && _ctx.onClickedAdd(...args))),
                disabled: !_ctx.meta.valid
              }, "登録", 8, _hoisted_8))
            : _createCommentVNode("", true),
          (!_ctx.isAdd)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-warning",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onClickedModify && _ctx.onClickedModify(...args))),
                disabled: !_ctx.meta.valid
              }, "修正", 8, _hoisted_9))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.isAdd)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  id: "can-initialize-password",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.canInitializePassword) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.canInitializePassword]
                ]),
                _hoisted_12
              ]),
              (!_ctx.isAdd)
                ? (_openBlock(), _createBlock(_component_loading_button, {
                    key: 0,
                    color: "danger",
                    disabled: !_ctx.canInitializePassword,
                    loading: _ctx.isWaitingInitialize,
                    onClick: _ctx.onClickedInitializePassword
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" パスワード初期化 ")
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading", "onClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 32)
    ]),
    _: 1
  }, 8, ["onDismiss"]))
}